import React from "react"

import "./Tooltip.scss"

type TooltipProps = {
  text: string
  className?: string
  children: React.ReactNode
}

function Tooltip(props: TooltipProps) {
  return (
    <div className={`tooltip ${props.className}`}>
      <span className="tooltiptext">{props.text}</span>
      {props.children}
    </div>
  )
}

export default Tooltip
